import { render, staticRenderFns } from "./legacy.vue?vue&type=template&id=be3ea1b0&scoped=true&lang=pug&"
import script from "./legacy.vue?vue&type=script&lang=js&"
export * from "./legacy.vue?vue&type=script&lang=js&"
import style0 from "./legacy.vue?vue&type=style&index=0&id=be3ea1b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3ea1b0",
  null
  
)

/* custom blocks */
import block0 from "./legacy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsBroadbandProviderJumbotron: require('/home/ubuntu/nuxt/bonkers/releases/20230928161648/components/products/broadband/provider-jumbotron.vue').default,WidgetsAlertMessage: require('/home/ubuntu/nuxt/bonkers/releases/20230928161648/components/widgets/alert-message.vue').default,SiteBlogNewsletterSignup: require('/home/ubuntu/nuxt/bonkers/releases/20230928161648/components/site/blog/newsletter-signup.vue').default})
